<template>
  <div>
    <MineHeaderView @click-icon="openMenu" />
    <MineMenuView ref="mmv" />
    <GoBackView />
    <div class="edit-box" style="height:calc(100vh - 113px)">
      <div class="frm-area">
        <div class="title">我的商品</div>
        <div class="frm-box">
          <van-form @submit="onSubmit">
            <div class="frm-item">
              <div class="frm-label">商品图片</div>
              <div style="padding: 16px 16px">
                <van-uploader
                  v-model="fileList1"
                  multiple
                  :after-read="afterRead1"
                  :max-count="10"
                  :before-read="beforeRead"
                  :before-delete="file1Delete1"
                >
                </van-uploader>
                <div v-if="islogo" style="color: #ee0a24; font-size: 12px">
                  请上传商品图片
                </div>
              </div>
            </div>
            <div class="frm-item">
              <div class="frm-label">商品名称</div>
              <van-field
                v-model="frm.name"
                placeholder="请填写商品名称"
                :rules="[{ required: true, message: '请填写商品名称' }]"
              />
            </div>
            <div class="frm-item">
              <div class="frm-label">起拍卖价</div>
              <van-field
                v-model="frm.starting_price"
                placeholder="请填写起拍卖价"
                :rules="[{ required: true, message: '请填写起拍卖价' }]"
              />
            </div>
            <div class="frm-item">
              <div class="frm-label">商品描述</div>

              <quill-editor v-model="frm.bewrite" :options="editorOption">
              </quill-editor>
            </div>
            <div class="frm-item">
              <div style="margin: 6px 12px">
                <van-radio-group v-model="frm.status" direction="horizontal">
                  <van-radio name="1">上架</van-radio>
                  <van-radio name="0">下架</van-radio>
                </van-radio-group>
              </div>
            </div>
            <div class="btn-box">
              <van-button
                block
                native-type="submit"
                :loading="posting"
                loading-text="提交中..."
                style="
                  background-color: #141423;
                  color: #fff;
                  border-radius: 8px;
                "
                >保存商品信息</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { getToken } from '@/utils/cookies'
import { MineHeaderView, MineMenuView } from './components/index'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'ShopProductView',
  components: { MineHeaderView, MineMenuView, GoBackView },
  data () {
    return {
      posting: false,
      islogo: false,
      fileList1: [],
      urllist: [],
      frm: {
        id: null,
        logo: null,
        name: null,
        starting_price: null,
        bewrite: null,
        carousel: '',
        status: '1'
      },
      editorOption: {
        placeholder: '请填写商品描述',
        theme: 'snow'
      }
    }
  },
  mounted () {
    this.frm.id = this.$route.query.id
    if (this.frm.id) {
      this.getData()
    }
  },
  methods: {
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getProductDetail',
        data: { id: this.frm.id }
      }).then(res => {
        this.frm.name = res.data.name
        this.frm.starting_price = res.data.starting_price
        this.frm.bewrite = res.data.bewrite
        this.frm.status = res.data.status.toString()

        this.fileList1 = []
        this.urllist = []
        this.frm.carousel = ''

        res.data.carousel_list.forEach(item => {
          this.fileList1.push({ url: item })
          this.urllist.push(item)
          this.frm.carousel += item + '|'
        })
      })
    },
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    async onSubmit () {
      if (!(this.urllist && this.urllist.length > 0)) {
        this.islogo = true
        return false
      }
      this.frm.carousel = ''
      this.urllist.forEach(item => {
        this.frm.carousel += item + '|'
      })
      this.frm.logo = this.urllist[0]

      if (this.frm.id && this.frm.id > 0) {
        this.onEdit()
        return
      }

      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'addShopProduct',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false

          this.fileList1 = []
          this.urllist = []
          this.frm = {
            id: null,
            logo: null,
            name: null,
            starting_price: null,
            bewrite: null,
            carousel: '',
            status: '1'
          }
        })
        .catch(() => {
          this.posting = false
        })
    },
    async onEdit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'editShopProduct',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false
          this.getData()
        })
        .catch(() => {
          this.posting = false
        })
    },
    beforeRead (file) {
      this.islogo = false
      const validTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml',
        'image/apng',
        'image/avif'
      ]
      if (!validTypes.includes(file.type)) {
        this.$toast.fail('请上传图片文件')
        return false
      }
      return true
    },
    async afterRead1 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            this.urllist.push(response.data.data.url)
            file.status = ''
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete1 (item, index) {
      console.log(index)
      this.fileList1 = this.removeByIndex(this.fileList1, index.index)
      this.urllist = this.removeByIndex(this.urllist, index.index)
    },
    removeByIndex (arr, index) {
      if (index < 0 || index >= arr.length) {
        console.warn(`下标 ${index} 超出数组范围 [0, ${arr.length - 1}]`)
        return arr
      }
      arr.splice(index, 1)
      return arr
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  height: calc(100vh - 130px);
  overflow: auto;
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 20px;
        text-align: center;
      }
    }
  }
}
::v-deep .ql-container {
  height: 240px;
}
::v-deep .ql-editor {
  min-height: 240px;
}
</style>
